// components/ComplianceNotice.jsx
import React from "react";
import { FaCheckCircle, FaInfoCircle, FaShieldAlt } from "react-icons/fa";

export default function ComplianceNotice() {
  return (
    <div className="rounded-3xl border border-emerald-200 bg-emerald-50 p-4 text-emerald-950 dark:border-emerald-900/60 dark:bg-emerald-950/30 dark:text-emerald-100">
      <div className="flex items-start gap-3">
        <div className="mt-1 rounded-2xl bg-emerald-600 text-white p-2">
          <FaShieldAlt />
        </div>

        <div className="min-w-0">
          <div className="font-semibold">
            Envoi professionnel : pas d’envoi massif brutal
          </div>

          <p className="mt-1 text-sm leading-relaxed opacity-90">
            Les campagnes doivent exclure automatiquement les désinscrits, les
            emails invalides et les bounces. L’objectif est d’envoyer moins, mais
            mieux : cible claire, email propre, bouton d’action, désinscription
            visible et test avant lancement.
          </p>

          <div className="mt-3 grid gap-2 md:grid-cols-3 text-xs">
            <Rule text="Désinscription obligatoire" />
            <Rule text="Test avant campagne" />
            <Rule text="Envoi progressif via worker" />
          </div>
        </div>
      </div>
    </div>
  );
}

function Rule({ text }) {
  return (
    <div className="inline-flex items-center gap-2 rounded-2xl bg-white/70 px-3 py-2 dark:bg-slate-900/50">
      <FaCheckCircle className="text-emerald-600" />
      <span>{text}</span>
    </div>
  );
}